import { cn, getAvatarColor } from "@nexus/ui";

import { getVendorInitials } from "../../lib/vendorInitials";

interface VendorIdentityProps {
  name: string;
  logoUrl: string | null;
  className?: string;
}

/**
 * Vendor logo, or initials on a color derived from the vendor name so the same
 * vendor always looks the same across rows. Rounded-square marks the vendor as
 * an organisation, not a person.
 */
export function VendorIdentity({ name, logoUrl, className }: VendorIdentityProps) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        loading="lazy"
        className={cn("size-7 shrink-0 rounded-md border border-border-subtle object-cover", className)}
      />
    );
  }

  return (
    <span
      aria-hidden
      style={{ backgroundColor: getAvatarColor(name) }}
      className={cn(
        "flex size-7 shrink-0 items-center justify-center rounded-md text-[11px] font-semibold text-foreground/80",
        className,
      )}
    >
      {getVendorInitials(name)}
    </span>
  );
}
